import { currencyConvertedAmount, getCurrencyConversionData } from './currencyConverter'

export function appendStructuredDataCarousel (hits) {
  const listElements = []

  // Structured-data prices follow the current locale's currency (mirrors Ruby
  // Listing#schema_currency / #schema_price). Prices in `hits` are GBP; convert
  // when the locale trades in a different currency. Currency comes from the Locale
  // registry via <body data-locale-currency>, so a new locale/currency just works.
  const currency = (document.body?.dataset?.localeCurrency || 'gbp').toLowerCase()
  const priceCurrency = currency.toUpperCase()
  const needsConversion = currency !== 'gbp'
  const { exchangeRate, markupPercentage } = needsConversion ? getCurrencyConversionData() : {}

  function schemaPrice (gbpPrice) {
    if (!needsConversion) return gbpPrice
    const converted = currencyConvertedAmount(gbpPrice, currency, exchangeRate, markupPercentage)
    return converted === null ? gbpPrice : converted.toFixed(2)
  }

  function formattedDate (d) {
    let month = String(d.getMonth() + 1)
    let day = String(d.getDate())
    const year = String(d.getFullYear())

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return `${day}-${month}-${year}`
  }

  function availabilityOfListing (listing) {
    if (listing.sold === false) {
      return 'http://schema.org/InStock'
    } else {
      return 'http://schema.org/OutOfStock'
    }
  }

  for (const key in hits) {
    if (Object.prototype.hasOwnProperty.call(hits, key) && hits[key].price !== undefined) {
      const position = key
      const url = `${window.location.host}/${hits[key].path_hierarchy}/${hits[key].slug}`
      const oneYearFromNow = new Date()
      oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1)
      if (hits[key].main_photo && hits[key].seller_name) {
        const listItem = {
          '@type': 'ListItem',
          position: position,
          item: {
            '@type': 'Product',
            name: hits[key].title,
            image: hits[key].main_photo.image.url,
            url: url,
            sku: `${hits[key].sku}`,
            offers: {
              '@type': 'Offer',
              price: schemaPrice(hits[key].price),
              priceCurrency: priceCurrency,
              priceValidUntil: formattedDate(oneYearFromNow),
              availability: availabilityOfListing(hits[key]),
              url: url,
              seller: {
                '@type': 'Organization',
                name: hits[key].seller_name
              },
              offeredBy: {
                '@type': 'Organization',
                name: hits[key].seller_name
              }
            }
          }
        }
        listElements.push(listItem)
      } else if (hits[key].seller_name) {
        const listItem = {
          '@type': 'ListItem',
          position: position,
          item: {
            '@type': 'Product',
            name: hits[key].title,
            url: url,
            sku: `${hits[key].sku}`,
            offers: {
              '@type': 'Offer',
              price: schemaPrice(hits[key].price),
              priceCurrency: priceCurrency,
              priceValidUntil: formattedDate(oneYearFromNow),
              availability: availabilityOfListing(hits[key]),
              url: url,
              seller: {
                '@type': 'Organization',
                name: hits[key].seller_name
              },
              offeredBy: {
                '@type': 'Organization',
                name: hits[key].seller_name
              }
            }
          }
        }
        listElements.push(listItem)
      } else if (hits[key].main_photo) {
        const listItem = {
          '@type': 'ListItem',
          position: position,
          item: {
            '@type': 'Product',
            name: hits[key].title,
            image: hits[key].main_photo.image.url,
            url: url,
            sku: `${hits[key].sku}`,
            offers: {
              '@type': 'Offer',
              price: schemaPrice(hits[key].price),
              priceCurrency: priceCurrency,
              priceValidUntil: formattedDate(oneYearFromNow),
              availability: availabilityOfListing(hits[key]),
              url: url
            }
          }
        }
        listElements.push(listItem)
      } else {
        const listItem = {
          '@type': 'ListItem',
          position: position,
          item: {
            '@type': 'Product',
            name: hits[key].title,
            url: url,
            sku: `${hits[key].sku}`,
            offers: {
              '@type': 'Offer',
              price: schemaPrice(hits[key].price),
              priceCurrency: priceCurrency,
              priceValidUntil: formattedDate(oneYearFromNow),
              availability: availabilityOfListing(hits[key]),
              url: url
            }
          }
        }
        listElements.push(listItem)
      }
    }
  };

  const seoTitle = document.querySelector('[data-id="content-title"]') || document.querySelector('[data-id="seller-content-title"]')
  const seoDescription = document.querySelector('[data-id="content-body-container"]') || document.querySelector('[data-id="seller-content-body"]')
  const scriptText = (seoTitle !== null && seoDescription !== null)
    ? {
        '@context': 'http://schema.org',
        '@type': 'ItemList',
        url: `${window.location.href}`,
        name: `${seoTitle.innerHTML}`,
        description: `${seoDescription.innerText}`,
        numberOfItems: `${hits.length}`,
        itemListElement: listElements
      }
    : {
        '@context': 'http://schema.org',
        '@type': 'ItemList',
        url: `${window.location.href}`,
        numberOfItems: `${hits.length}`,
        itemListElement: listElements
      }

  const s = document.createElement('script')
  s.type = 'application/ld+json'
  s.text = JSON.stringify(scriptText)
  if (seoTitle !== null) {
    document.head.appendChild(s)
  }
};
